import { LayoutDashboard, Users, ShoppingCart, Layers, UserCog } from "lucide-react";

export const ADMIN_NAV = [
    { to: "/admin", label: "Dashboard", icon: LayoutDashboard },
    { to: "/admin/leads", label: "Leads", icon: Users },
    { to: "/admin/orders", label: "Orders", icon: ShoppingCart },
    { to: "/admin/services", label: "Services", icon: Layers },
    { to: "/admin/bdes", label: "BDEs", icon: UserCog },
];
